"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Card_1 = __importDefault(require("@mui/material/Card"));
const styles_1 = require("@mui/material/styles");
const NumericScale_1 = __importDefault(require("../NumericScale"));
const TextFeedback_1 = __importDefault(require("../TextFeedback"));
const feedbackQuestions_1 = __importDefault(require("../../common/feedbackQuestions"));
const FeedbackCopy_1 = __importDefault(require("../../common/FeedbackCopy"));
const Header = styled_components_1.default.p `
  ${({ theme }) => theme.typography.variants.primary.main};
  color: ${({ theme }) => theme.palette.primary.main};
  margin-top: 0;
`;
const Paragraph = styled_components_1.default.p `
  ${({ theme }) => theme.typography.variants.primary.main};
  margin: 0;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "max-width",
    values: { lg: "581px" },
})};
`;
/** Quick trap to filter out spam */
const HoneyPotInput = styled_components_1.default.input `
  display: none;
`;
const SubmitButtonWrapper = styled_components_1.default.div `
  display: flex;
  margin-top: 40px;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "justify-content",
    values: { md: "flex-end" },
})};

  button {
    min-width: 100px;

    ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "width",
    values: { lg: "auto", xs: "100%" },
})};
  }
`;
const QuestionWrapper = (0, styled_components_1.default)(Card_1.default) `
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    padding: 24px 24px 16px;
    border-radius: 0;
    flex-shrink: 0;
    border-bottom: ${({ $showBorder, theme }) => $showBorder ? `1px solid ${theme.palette.gray[10]}` : "none"};

    &.MuiPaper-rounded {
      border-radius: 0;
    }
  }
`;
const ErrorBlock = styled_components_1.default.div `
  margin: 16px 0;
  ${(props) => props.theme.typography.variants.primary.small};
  color: ${(props) => props.theme.palette.status.error};
  display: flex;

  .BuoyIcon-Container {
    margin-right: 8px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    margin: 8px 24px;
  }
`;
const InputWrapper = styled_components_1.default.div `
  border: ${(props) => props.$hasError ? `1px solid ${props.theme.palette.status.error}` : "none"};
  border-radius: 4px;
  padding: ${(props) => (props.$hasError ? "8px" : "none")};
  margin-top: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    padding: ${(props) => (props.$hasError ? "8px" : "0 24px")};
    overflow: scroll;
    margin: ${(props) => (props.$hasError ? "8px 16px" : "0")};
  }
`;
const Offset = styled_components_1.default.div `
  margin: 24px 0;
`;
const StyledAppBar = (0, styled_components_1.default)(AppBar_1.default) `
  top: auto;
  bottom: 0;
  padding: 24px 16px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-top: ${({ $showBorder, theme }) => $showBorder ? `1px solid ${theme.palette.gray[10]}` : "none"};
`;
const SurveyQuestion = ({ isMobile, onAnswerSubmit, lastSubmittedQuestionIndex, }) => {
    const [activePage, setActivePage] = (0, react_1.useState)(lastSubmittedQuestionIndex != null ? lastSubmittedQuestionIndex + 1 : 0);
    const [isFormDisabled, setIsFormDisabled] = (0, react_1.useState)(false);
    const [answerValue, setAnswerValue] = (0, react_1.useState)();
    const [scrollTarget, setScrollTarget] = (0, react_1.useState)(undefined);
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const theme = (0, styles_1.useTheme)();
    const handleAnswerChange = (value) => {
        setAnswerValue(value);
        setHasError(false);
    };
    const isScrollable = scrollTarget && scrollTarget?.offsetHeight < scrollTarget?.scrollHeight;
    const activeQuestion = feedbackQuestions_1.default[activePage];
    const answerRequired = !activeQuestion.optional;
    const goToNextPage = () => {
        setAnswerValue(undefined);
        setHasError(false);
        setActivePage(activePage + 1);
    };
    const submitResponse = () => {
        if (isFormDisabled || (answerRequired && !answerValue)) {
            setHasError(true);
            return;
        }
        const surveyComplete = activePage === feedbackQuestions_1.default.length - 1;
        onAnswerSubmit(activeQuestion.question, answerValue || "", activePage);
        if (!surveyComplete) {
            goToNextPage();
        }
    };
    const onHoneyPotCapture = () => {
        setIsFormDisabled(true);
    };
    const submitButton = ((0, jsx_runtime_1.jsx)(common_buoy_button_1.PrimaryButton, { "data-testid": "submit-button", onClick: submitResponse, children: activeQuestion.inputType === "text"
            ? FeedbackCopy_1.default.Submit
            : FeedbackCopy_1.default.Next }));
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(QuestionWrapper, { "$showBorder": !!isScrollable, elevation: 0, children: [(0, jsx_runtime_1.jsxs)(Header, { children: ["Question ", activePage + 1, " of ", feedbackQuestions_1.default.length] }), (0, jsx_runtime_1.jsx)(Paragraph, { children: activeQuestion.question })] }), (0, jsx_runtime_1.jsx)(HoneyPotInput, { "aria-hidden": true, onChange: onHoneyPotCapture }), hasError && ((0, jsx_runtime_1.jsxs)(ErrorBlock, { children: [(0, jsx_runtime_1.jsx)(common_buoy_icons_1.AlertIcon, { size: 16 }), "Please select a response"] })), (0, jsx_runtime_1.jsxs)(InputWrapper, { ref: (node) => {
                    if (node) {
                        setScrollTarget(node);
                    }
                }, "$hasError": hasError, children: [activeQuestion.inputType === "numeric" && activeQuestion.scale && ((0, jsx_runtime_1.jsx)(NumericScale_1.default, { isMobile: isMobile, onChange: handleAnswerChange, scale: activeQuestion.scale, value: answerValue })), activeQuestion.inputType === "text" && ((0, jsx_runtime_1.jsx)(TextFeedback_1.default, { handleValueChange: handleAnswerChange }))] }), isMobile ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledAppBar, { "$showBorder": !!isScrollable, elevation: 0, position: "fixed", children: submitButton }), (0, jsx_runtime_1.jsx)(Offset, { style: theme.mixins.toolbar })] })) : ((0, jsx_runtime_1.jsx)(SubmitButtonWrapper, { children: submitButton }))] }, activePage));
};
exports.default = SurveyQuestion;
//# sourceMappingURL=index.js.map